import { call, put, takeLatest } from "redux-saga/effects";
import { schema } from "normalizr";
import { authorizedRequest } from "utils/api";

export const CASH_FLOWS_GET_REQUEST = "CASH_FLOWS_GET_REQUEST";
export const CASH_FLOWS_GET_FAILURE = "CASH_FLOWS_GET_FAILURE";
export const CASH_FLOWS_GET_SUCCESS = "CASH_FLOWS_GET_SUCCESS";

export const CASH_FLOWS_CALCULATE_REQUEST = "CASH_FLOWS_CALCULATE_REQUEST";
export const CASH_FLOWS_CALCULATE_FAILURE = "CASH_FLOWS_CALCULATE_FAILURE";
export const CASH_FLOWS_CALCULATE_SUCCESS = "CASH_FLOWS_CALCULATE_SUCCESS";

export const CASH_FLOWS_KEY = "cashFlows";
export const CASH_FLOWS_ENTITY = new schema.Entity(CASH_FLOWS_KEY, {});
export const CASH_FLOWS_SCHEMA = [CASH_FLOWS_ENTITY];

const initialState = {};

export default function cashFlowsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CASH_FLOWS_GET_SUCCESS:
      return {
        ...state,
        data: payload.data
      };

    case CASH_FLOWS_CALCULATE_SUCCESS:
      return {
        ...state,
        data: payload.data
      };

    default:
      return state;
  }
}

// GET CashFlows
export function getCashFlows(payload) {
  return {
    type: CASH_FLOWS_GET_REQUEST,
    payload
  };
}
export function getCashFlowsSuccess(payload) {
  return {
    type: CASH_FLOWS_GET_SUCCESS,
    payload
  };
}
export function getCashFlowsFailure(error) {
  return {
    type: CASH_FLOWS_GET_FAILURE,
    error
  };
}

// CALCULATE CashFlows
export function calculateCashFlows(payload) {
  return {
    type: CASH_FLOWS_CALCULATE_REQUEST,
    payload
  };
}
export function calculateCashFlowsSuccess(payload) {
  return {
    type: CASH_FLOWS_CALCULATE_SUCCESS,
    payload
  };
}
export function calculateCashFlowsFailure(error) {
  return {
    type: CASH_FLOWS_CALCULATE_FAILURE,
    error
  };
}

// Saga GET CashFlows
function* getCashFlowsSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.payload}/cashflows`,
      "GET"
    );
    yield put(getCashFlowsSuccess(response));
  } catch (error) {
    yield put(getCashFlowsFailure(error));
  }
}

// Saga CALCULATE CashFlows
function* calculateCashFlowsSaga(payload) {
  try {
    const response = yield call(
      authorizedRequest,
      `/deals/${payload.payload.id}/cashflows`,
      "POST",
      payload.payload.values
    );
    yield put(calculateCashFlowsSuccess(response));
  } catch (error) {
    yield put(calculateCashFlowsFailure(error));
  }
}

export function* cashFlowsSaga() {
  yield takeLatest(CASH_FLOWS_GET_REQUEST, getCashFlowsSaga);
  yield takeLatest(CASH_FLOWS_CALCULATE_REQUEST, calculateCashFlowsSaga);
}
